<template>
  <card-seplag titulo="Solicitações de Verba Indenizatória">
    <h3 class="p-col-12">Filtros de busca</h3>
    <div class="p-col-12 p-md-12" style="display: flex">
      <Dropdown
        v-model="statSelecionado"
        :options="listaStatus"
        optionLabel="name"
        optionValue="code"
        placeholder="Filtro de Status"
        filter
        style="width: 100%; margin-left: 2px"
      />
      <Dropdown
        v-model="statPeticionamentoSelecionado"
        :options="listaStatusPeticionamento"
        optionLabel="name"
        optionValue="code"
        placeholder="Filtro de Status de peticionamento"
        filter
        style="width: 100%; margin-left: 2px"
      />
      <InputText
        type="text"
        id="filtroNomeCpfMAtricula"
        v-model="filtroNomeCpfMAtricula"
        style="margin-left: 2px"
        placeholder="Codigo ou Nome ou Matricula ou CPF"
        aria-placeholder="Filtro Nome ou Matricula ou CPF"
      />
    </div>
    <h4 class="p-col-12">Ordenação</h4>
    <div class="p-col-12 p-md-6" style="display: flex">
      <Dropdown
        v-model="statCampoOrdenacaoSelecionado"
        :options="listaCamposOrdenacao"
        optionLabel="name"
        optionValue="code"
        placeholder="Filtro de ordenação"
        filter
        style="width: 100%; margin-left: 2px"
      />
      <Dropdown
        v-model="statOrdemOrdenacaoSelecionado"
        :options="listaOrdemOrdenacao"
        placeholder="Filtro de ordem ordenação"
        filter
        style="width: 100%; margin-left: 2px"
      />
    </div>
    <div class="p-col-12"></div>
    <div class="p-col-12 p-md-2">
      <Button
        type="button"
        icon="pi pi-search"
        label="Buscar"
        style="margin-left: 2px"
        v-tooltip.top="'buscar'"
        @click="paginacaoSolicitacao(10, 0)"
      />
    </div>
    <DataTable
      :value="listaSolicitacoes.content"
      :paginator="true"
      :rows="10"
      responsiveLayout="scroll"
      :lazy="true"
      :totalRecords.sync="listaSolicitacoes.totalElements"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      @page="
        paginacaoSolicitacao(
          $event.originalEvent.rows,
          $event.originalEvent.page
        )
      "
      class="p-col-12 p-datatable-responsive"
    >
      <Column field="idenSolicitacaoVerbaResc" header="Código"></Column>
      <Column field="numrMatricula" header="Matrícula"></Column>
      <Column field="nomeSolicitante" header="Nome"></Column>
      <Column
        field="dataSolicitacaoVerbaResc"
        header="Data Solicitação"
      ></Column>
      <Column field="dataAceiteVerbaResc" header="Data Aceite"></Column>
      <Column field="dataEncerramento" header="Data encerramento"></Column>
      <Column field="flagPeticionado" header="Peticionado?">
        <template #body="slotProps">
          {{ buscarPeticionamento(slotProps.data.flagPeticionado) }}
        </template>
      </Column>
      <Column field="statAndamento" header="Status">
        <template #body="slotProps">
          {{
            slotProps.data.statAndamento
              ? buscaStatus(slotProps.data.statAndamento)
              : ""
          }}
        </template>
      </Column>
      <Column bodyStyle="text-align: center;" header="Ação">
        <template #body="slotProps">
          <Button
            type="button"
            icon="pi pi-eye"
            class="buttonVisualizar"
            v-tooltip.top="'Visualizar Despacho'"
            @click="visualizarDespacho(slotProps.data)"
            v-if="
              slotProps.data.statAndamento == 'PROPOSTA_ACEITA' ||
              slotProps.data.statAndamento == 'EM_FILA_DE_PAGAMENTO' ||
              slotProps.data.statAndamento == 'SOLICITACAO_CONCLUIDA' ||
              slotProps.data.statAndamento == 'PROPOSTA_EMITIDA' ||
              slotProps.data.statAndamento == 'ENCERRADO'
            "
          />
          <Button
            type="button"
            icon="pi pi-clock"
            class="buttonHistorico"
            v-tooltip.top="'Visualizar Histórico'"
            style="margin-left: 2px"
            @click="abrindoHistorico(slotProps.data)"
            v-if="
              slotProps.data.statAndamento == 'PROPOSTA_ACEITA' ||
              slotProps.data.statAndamento == 'EM_FILA_DE_PAGAMENTO' ||
              slotProps.data.statAndamento == 'SOLICITACAO_CONCLUIDA' ||
              slotProps.data.statAndamento == 'PROPOSTA_EMITIDA' ||
              slotProps.data.statAndamento == 'ENCERRADO'
            "
          />
          <Button
            type="button"
            icon="pi pi-replay"
            class="buttonReverter"
            v-tooltip.top="'Reverter Solicitação'"
            style="margin-left: 2px"
            @click="confirmarReversao(slotProps.data)"
            v-if="verificarReversao(slotProps.data.statAndamento)"
          />
          <Button
            type="button"
            icon="pi pi-print"
            v-tooltip.top="'Imprimir Acordo'"
            style="margin-left: 2px"
            @click="abrirAcordoFirmado(slotProps.data.idenSolicitacaoVerbaResc)"
            v-if="
              slotProps.data.statAndamento == 'PROPOSTA_ACEITA' ||
              slotProps.data.statAndamento == 'EM_FILA_DE_PAGAMENTO' ||
              slotProps.data.statAndamento == 'SOLICITACAO_CONCLUIDA'
            "
          />
          <Button
            type="button"
            icon="pi pi-wallet"
            class="p-button-warning"
            v-tooltip.top="'Criar Despacho'"
            v-if="
              slotProps.data.statAndamento == 'RECEBIDA' ||
              slotProps.data.statAndamento == 'EM_ANALISE' ||
              slotProps.data.statAndamento == 'EM_REVISAO'
            "
            style="margin-left: 2px"
            @click="despacho(slotProps.data)"
          ></Button>
          <Button
            type="button"
            icon="pi pi-check-circle"
            style="margin-left: 2px"
            @click="peticionarSolicitacao(slotProps.data)"
            v-tooltip.top="'Selecionar peticionamento'"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      header="Selecionar peticionamento"
      :visible.sync="visualizarModalPeticionamento"
      :containerStyle="{ width: '50%', height: '35%' }"
      :modal="true"
    >
      <h4>Selecione o status de peticionamento para a solicitação</h4>
      <div style="display: flex; align-items: center">
        <Dropdown
          v-model="selecaoPeticionamento"
          :options="listaSelecaoPeticionamento"
          optionLabel="name"
          optionValue="code"
          style="width: 50%; margin-left: 2px"
        />
      </div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <div class="p-col-12"></div>
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="fecharModal()"
          class="p-button-text"
        />
        <Button
          label="Salvar"
          icon="pi pi-check"
          @click="alterarStatusPeticionamento()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Finalizar proposta"
      :visible.sync="visualizarModalReverterSolicitacao"
      :containerStyle="{ width: '350px' }"
      :modal="true"
    >
      <div
        class="confirmation-content"
        style="display: flex; align-items: center"
      >
        <i
          class="pi pi-exclamation-triangle mr-3"
          style="font-size: 2rem; color: red; margin-right: 10px"
        />
        <span
          >Você tem certeza de que deseja reverter a solicitação de
          {{
            solicitacaoSelecionada
              ? solicitacaoSelecionada.nomeSolicitante
              : ""
          }}?
        </span>
      </div>
      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          @click="fecharModal()"
          class="p-button-text"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="solicitarReversao()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Movimentação Solicitação"
      :visible.sync="visualizarModalMovSolicitacao"
      :containerStyle="{ width: '50%' }"
      :modal="true"
    >
      <Timeline :value="movimentacaoSolicitacao">
        <template #opposite="slotProps">
          <small class="p-text-secondary">{{
            slotProps.item.dataSolicitacaoMovimentacao
          }}</small>
        </template>
        <template #content="slotProps">
          {{ slotProps.item.descSolicitacaoMovimentacao }}<br />
          <span v-if="slotProps.item.matricula">{{
            slotProps.item.matricula + " - " + slotProps.item.nome
          }}</span>
        </template>
      </Timeline>
    </Dialog>

    <CardExibirPDF
      v-if="pdfElement && navegador != 'Safari'"
      v-model="exibirPDF"
      :nomeDocumento="nomeDocumentoPDF"
      :tituloTela="'PDF do Acordo'"
      :position="'top'"
      :tamanhoTela="'55.em'"
      :alturaTela="'55.em'"
      :pdfElement="pdfElement"
    />
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
import { baseApiUrl, isUserTemPerssaoGlobal } from "@/config/global";
export default {
  name: "solicitaVerbaProcurador",
  components: { CardSeplag, CardExibirPDF },
  data() {
    return {
      listaSolicitacoes: [],
      movimentacaoSolicitacao: [],
      matricula: null,
      vinculo: null,
      idenVinculo: null,
      statSelecionado: null,
      statPeticionamentoSelecionado: null,
      statCampoOrdenacaoSelecionado: null,
      statOrdemOrdenacaoSelecionado: null,
      exibirPDF: false,
      visualizarModalReverterSolicitacao: false,
      visualizarModalMovSolicitacao: false,
      solicitacaoSelecionada: null,
      nomeDocumentoPDF: "Acordo",
      pdfElement: null,
      navegador: null,
      visualizarModalPeticionamento: false,
      filtroNomeCpfMAtricula: "",
      selecaoPeticionamento: null,
      listaSelecaoPeticionamento: [
        { code: "N", name: "Não peticionado" },
        { code: "S", name: "Peticionado" },
        { code: "F", name: "Finalizado" },
      ],
      listaStatus: [
        { code: "TODOS", name: "Todos" },
        { code: "RECEBIDA", name: "Solicitado" },
        { code: "EM_ANALISE", name: "Despacho Em Analise" },
        { code: "EM_REVISAO", name: "Despacho Em Revisão" },
        { code: "PROPOSTA_EMITIDA", name: "Proposta Emitida" },
        {
          code: "EM_FILA_DE_PAGAMENTO",
          name: "Solicitações Em Fila para Pagamento",
        },
        { code: "SOLICITACAO_CONCLUIDA", name: "Solicitações Concluida" },
        { code: "ENCERRADO", name: "Despacho encerrado" },
      ],
      listaStatusPeticionamento: [
        { code: "TODOS", name: "Todos" },
        { code: "N", name: "Solicitações não peticionadas" },
        { code: "S", name: "Solicitações peticionadas" },
        { code: "F", name: "Solicitações que não precisam ser peticionadas" },
      ],
      listaCamposOrdenacao: [
        { code: "idenSolicitacaoVerbaResc", name: "Codigo" },
        { code: "dataSolicitacaoVerbaResc", name: "Data solicitação" },
        { code: "dataAceiteVerbaResc", name: "Data aceite proposta" },
        { code: "dataSolicitacaoMovimentacao", name: "Data encerramento" },
      ],
      listaOrdemOrdenacao: ["ASC", "DESC"],
    };
  },
  methods: {
    carregarDados() {
      this.matricula =
        this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.matricula;
      this.vinculo =
        this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.vinculo;
      for (
        let i = 0;
        i < this.$store.getters.getUser.contaAcesso.listaVinculo.length;
        i++
      ) {
        if (
          this.$store.getters.getUser.contaAcesso.listaVinculo[i].numrVinculo ==
          this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap
            .vinculo
        ) {
          this.idenVinculo =
            this.$store.getters.getUser.contaAcesso.listaVinculo[i].idenVinculo;
          break;
        }
      }
      this.statSelecionado = "TODOS";
      this.statPeticionamentoSelecionado = "TODOS";
      this.statCampoOrdenacaoSelecionado = "idenSolicitacaoVerbaResc";
      this.statOrdemOrdenacaoSelecionado = "ASC";

      if (!isUserTemPerssaoGlobal("solicitaVerbaDespachoFinalizar")) {
        this.listaStatus = [
          { code: "RECEBIDA", name: "Solicitado" },
          { code: "EM_ANALISE", name: "Despacho Em Analise" },
        ];
      }
      this.paginacaoSolicitacao(10, 0);
    },
    paginacaoSolicitacao(row = 10, page = 0) {
      let statusAndamento =
        this.statSelecionado == "TODOS" ? null : this.statSelecionado;
      let flagPeticionado =
        this.statPeticionamentoSelecionado == "TODOS"
          ? null
          : this.statPeticionamentoSelecionado;
      let filtro = this.filtroNomeCpfMAtricula;
      let ordenacao = this.statCampoOrdenacaoSelecionado;
      let ordemOrdenacao = this.statOrdemOrdenacaoSelecionado;

      let jsonBody = {
        statusAndamento,
        flagPeticionado,
        filtro,
      };
      this.$http
        .post(
          `${baseApiUrl}/solicitacoes-verba-rescisoria/parametros?size=${row}&page=${page}&sort=${ordenacao},${ordemOrdenacao}`,
          JSON.stringify(jsonBody)
        )
        .then((res) => {
          this.listaSolicitacoes = res.data;
        });
    },
    despacho(data) {
      this.$router.push({
        name: "solicitaVerbaDespacho",
        query: { id: data.idenSolicitacaoVerbaResc },
      });
    },
    visualizarDespacho(data) {
      this.$router.push({
        name: "solicitaVerbaDespachoView",
        query: { id: data.idenSolicitacaoVerbaResc },
      });
    },
    envioPagamento(data) {
      this.$http
        .put(
          `${baseApiUrl}/solicitacoes-verba-rescisoria/encaminhar-para-pagamento/${data.idenSolicitacaoVerbaResc}`
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary:
              "Solicitação Enviada para Pagamento com sucesso. Porfavor Aguarde o tramite do processo.",
            life: 3000,
          });
          this.carregarDados();
        });
    },
    peticionarSolicitacao(data) {
      this.solicitacaoSelecionada = data;
      this.visualizarModalPeticionamento = true;
    },
    alterarStatusPeticionamento() {
      //console.log(this.selecaoPeticionamento)
      let jsonBody = {
        flagPeticionar: this.selecaoPeticionamento,
      };
      this.$http
        .put(
          `${baseApiUrl}/solicitacoes-verba-rescisoria/peticionar/${this.solicitacaoSelecionada.idenSolicitacaoVerbaResc}`,
          JSON.stringify(jsonBody)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary:
              "Solicitação foi atualizada com peticionamento selecionado.",
            life: 3000,
          });
          this.visualizarModalPeticionamento = false;
          this.solicitacaoSelecionada = null;
          this.selecaoPeticionamento = null;
          this.paginacaoSolicitacao();
        });
    },
    buscaStatus(code) {
      let name = "";
      for (let i = 0; i < this.listaStatus.length; i++) {
        if (this.listaStatus[i].code == code) {
          name = this.listaStatus[i].name;
          break;
        }
      }
      return name;
    },
    buscarPeticionamento(flagPeticionado) {
      if (flagPeticionado == "S") {
        return "Já Peticionado";
      }
      if (flagPeticionado == "N") {
        return "Não Peticionado";
      }
      return "Finalizado";
    },
    abrindoHistorico(data) {
      this.$http
        .get(
          `${baseApiUrl}/movimentacoes/solicitacao/${data.idenSolicitacaoVerbaResc}`
        )
        .then((res) => {
          this.visualizarModalMovSolicitacao = true;
          this.movimentacaoSolicitacao = res.data;
        });
    },
    detectaNavegador() {
      var isOpera = !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
      var isFirefox = typeof InstallTrigger !== "undefined"; // Firefox 1.0+
      var isChrome = !!window.chrome && !isOpera; // Chrome 1+
      var isIE = /*@cc_on!@*/ false || !!document.documentMode; // At least IE6

      var userAgent = navigator.userAgent;
      var isSafari =
        userAgent.indexOf("Safari") >= 0 && userAgent.indexOf("Chrome") === -1;

      if (isOpera) {
        this.navegador = "Opera";
        return 1;
      } else if (isFirefox) {
        this.navegador = "Firefox";
        return 2;
      } else if (isChrome) {
        this.navegador = "Chrome";
        return 3;
      } else if (isSafari) {
        this.navegador = "Safari";
        return 4;
      } else if (isIE) {
        this.navegador = "IE";
        return 5;
      } else {
        this.navegador = "OUTRO";
        return 0;
      }
    },
    abrirAcordoFirmado(idenSolicitacaoVerbaResc) {
      this.$http
        .get(
          `${baseApiUrl}/relatorios/verbarescisoria/termo-aceite/${idenSolicitacaoVerbaResc}`
        )
        .then((res) => {
          this.pdfElement = res.data.dadosRelatorioBase64;
          this.nomeDocumentoPDF = res.data.nomeArquivo;
          this.exibirPDF = true;

          const byteCharacters = atob(res.data.dadosRelatorioBase64);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, "Acordo.pdf");
          } else {
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = "Acordo.pdf";
            link.style.display = "none";

            if (this.detectaNavegador() === 4) {
              this.exibirPDF = false;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              setTimeout(() => {
                window.open(objectUrl, "_blank");
              }, 1000);
            }

            setTimeout(() => {
              URL.revokeObjectURL(objectUrl);
            }, 2000);
          }
        });
    },
    verificarReversao(statusAndamento) {
      if (statusAndamento == "EM_FILA_DE_PAGAMENTO") {
        if (isUserTemPerssaoGlobal("solicitaVerbaReverterSolicitacao")) {
          return true;
        }
      } else if (statusAndamento == "PROPOSTA_EMITIDA") {
        return true;
      } else if (statusAndamento == "ENCERRADO") {
        return true;
      }
      return false;
    },
    confirmarReversao(data) {
      this.solicitacaoSelecionada = data;
      this.visualizarModalReverterSolicitacao = true;
    },
    solicitarReversao() {
      if (this.solicitacaoSelecionada) {
        let url = "/solicitacoes-verba-rescisoria/reverter";
        this.$http
          .put(
            `${baseApiUrl}${url}/${this.solicitacaoSelecionada.idenSolicitacaoVerbaResc}`
          )
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Solicitação Revertida para Em Analise com sucesso.",
              life: 3000,
            });
            this.paginacaoSolicitacao();
          });
      }
      this.fecharModal();
    },
    fecharModal() {
      this.visualizarModalPeticionamento = false;
      this.visualizarModalReverterSolicitacao = false;
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
.textoInformativoVerbaIdenizatoria {
  line-height: 1.5;
  margin: 0;
  text-align: justify;
}
.flagNaoPeticionado {
  background-color: #5a65a0;
  color: white;
  transition: background-color 0.3s ease;
}
.flagPeticionado {
  background-color: #5c6bc0;
  color: white;
  transition: background-color 0.3s ease;
}

.flagPeticionado:hover {
  background-color: #5c6bc0;
}

.flagNaoPeticionado:hover {
  background-color: #5c6bc0;
}
.buttonVisualizar {
  background-color: darkgray;
  border-color: gray;
  color: white;
  transition: background-color 0.3s ease;
}
.buttonVisualizar:hover {
  background-color: darkgray;
}
.buttonHistorico {
  background-color: #ff9800;
  border-color: #ff9800;
  color: white;
  transition: background-color 0.3s ease;
}
.buttonHistorico:hover {
  background-color: #ff9800;
}
.buttonReverter {
  background-color: rgb(163, 43, 43);
  border-color: rgb(78, 21, 21);
  color: white;
  transition: background-color 0.3s ease;
}
.buttonReverter:hover {
  background-color: rgb(163, 43, 43);
}
</style>
